import Tooltips from "../ui/tooltip";
import NavMenuItem from "../ui/nav-menu-item";
import { Search } from "lucide-react";
import ActionIcon from "../ui/action-icon";
import UserContext from "../../contexts/user-context";
import BusinessContext from "../../contexts/business-context";
import { useContext } from "react";

const TopNav = () => {
    const userCtx = useContext(UserContext);
    const businessCtx = useContext(BusinessContext);
    const business = businessCtx.activeBusiness;
    const user = userCtx.user;

    if (user.is_pseudonymous || business.is_pseudonymous) {
        return null;
    }

    return (
            <div className="stickty top-0 grid gap-[4px]">
                <Tooltips position="right" content="This feature is coming soon">
                    <div
                        // onClick={toggleModal}
                        className={`grid grid-flow-col justify-start items-center cursor-not-allowed w-full text-[12px] h-[35px] px-[27px] gap-[12px] rounded-[8px] custom-text-grey-800 `}>
                        <ActionIcon color="custom-text-grey-800 !cursor-not-allowed">
                            <Search size={16} color="currentColor" />
                        </ActionIcon>
                        <span className={`custom-text-grey-500  poppins-medium text-[12px] tracking-[0.5px]`}>Search</span>
                    </div>
                </Tooltips>
                <NavMenuItem history={() => { setHistory(true) }} icon="sparkles" href="/chats">
                    Workpeg AI
                </NavMenuItem>
                <NavMenuItem icon="house" href="/">
                    Home
                </NavMenuItem>
            </div>
    );
};

export default TopNav;